import { Formik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import moment from "moment";
import DesignFieldWrapper from "./DesignFieldWrapper";
import { useSubmitDesignForm } from "./api/hooks/useSubmitDesignForm";

const initialValues = {
  category: "",
  subCategory: "",
  quantity: "",
  requestType: "",
  submissionType: "",
  creativeType: "",
  referenceUrl: "",
  description: "",
  remarks: "",
  proposedDeadline: "",
  reviewer: "",
  lead: "",
};

const validationSchema = Yup.object({
  category: Yup.object().required("Required"),
  subCategory: Yup.object().required("Required"),
  spocType: Yup.object().required("Required"),
  quantity: Yup.number().positive().nonNullable().required("Required"),
  requestType: Yup.object().required("Required"),
  submissionType: Yup.object().required("Required"),
  creativeType: Yup.object().required("Required"),
  referenceUrl: Yup.string().url("Invalid URL").required("Required"),
  description: Yup.string().required("Required"),
  remarks: Yup.string(),
});

const DesignRequisitionForm = () => {
  const { submitDesignForm } = useSubmitDesignForm();
  const {
    user: { id: requester },
  } = useSelector((store) => store.user);

  const handleSubmit = (values, { resetForm }) => {
    const payload = {
      category: values?.category?.value,
      subCategory: values?.subCategory?.value,
      quantity: values?.quantity,
      spocType: values?.spocType?.value,
      requestType: values?.requestType?.value,
      submissionType: values?.submissionType?.value,
      creativeType: values?.creativeType?.value,
      referenceUrl: values?.referenceUrl,
      remarks: values?.remarks,
      description: values?.description,
      proposedDeadline: moment(
        values?.proposedDeadline,
        "Do MMMM, YYYY"
      ).format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(India Standard Time)]"),
      reviewer: values?.reviewer?.value,
      lead: values?.lead?.value,
      requester,
    };

    submitDesignForm(
      {
        payload,
      },
      {
        onSuccess: () => {
          toast.success("Form Submitted Successfully");
          resetForm();
        },
      }
    );
  };

  return (
    <div className="w-full h-[calc(100vh-75px)] top-[75px] overflow-hidden relative">
      <div className="w-3/5 h-full overflow-auto justify-center m-auto border shadow-md rounded">
        <div className="flex justify-center mb-6 items-start bg-[#5d51d3] text-white p-3 text-lg">
          <h1>Design Requisition Form</h1>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formikData) => <DesignFieldWrapper formikData={formikData} />}
        </Formik>
      </div>
    </div>
  );
};

export default DesignRequisitionForm;
